import { EntregaDeTrabalhoFormato } from './models'

export const RESPONSIBLE_LABELS: Record<'student' | 'other', string> = {
  student: 'O próprio aluno',
  other: 'Outros'
}

export const FORMAT_LABELS: Record<EntregaDeTrabalhoFormato, string> = {
  presencial: 'Presencial',
  'online-ao-vivo': 'EAD Ao Vivo'
}

// Sentence case, igual ao EEntregaDeTrabalhoType (models.tsx) usado na listagem/filtro.
export const WORK_TYPE_LABELS: Record<'pesquisa-de-campo' | 'trabalho-de-conclusão', string> = {
  'pesquisa-de-campo': 'Pesquisa de campo',
  'trabalho-de-conclusão': 'Trabalho de conclusão'
}

// Limites do upload, espelhando EntregaDeTrabalhoUploadCreate (max:25600) e o storeUpload do
// backend. A lista de extensões e a validação em si são do token `workFile` em
// `components/FileInput/fileTypes.ts`.
export const MAX_FILES = 10

export const MAX_FILE_SIZE_MB = 25

export const MAX_TOTAL_SIZE_MB = 100
